export function putPersonalRelationAgreement({ jwt, params }) {
  return fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/pd/putPersonalRelationAgreements`,
    {
      method: "PUT",
      body: JSON.stringify({
        personal_relation_agree: String(params.personalRelationAgree),
        ...(params.cpEntry !== undefined ? { cp_entry: params.cpEntry } : {}),
      }),
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${jwt}`,
      },
    }
  )
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}
